import axios from "axios";

// getehr.synapstics.com no longer resolves -- the Azure estate it lived on
// is gone. Every request from this app is built from these two constants,
// so pointing them at the retired host meant the form definition never
// loaded and /answer rendered an empty form with just a Submit button.
export const BASE_URL ='https://getehr.curegrid.co/api/caremeapp'

export const APP_BASE_URL="curegrid.co"; 

export const headers= {
    "Content-Type": "application/json",
    "Authorization": "a7143772a09f993125901ea752bfd4fcf4b31d29"
   }

export const PostApi = async(data)=>{
    console.log(data)
    let url = data.url
    let params=data.values
    var val = ''
    await axios.post(BASE_URL+url,params,{headers}).then((res)=>{
        console.log(res.data)
       if(res){
        val= res.data
       }
       else{val= "error"}
    })
    .catch((err)=>{
        console.log(err)
    })
    return val
}

export const getProdKey={};

export const GetApi=async(data)=>{
    console.log(data)
    let url = data.url
    var val = ''
   await axios.get(BASE_URL+url,{headers}).then((res)=>{
      console.log(res.data)
       if(res){
        val= res.data
       }
       else{val= "error"}
    })
    .catch((err)=>{
        console.log(err)
    })
    return val
}



const languageCode = {
    'english': 'en',
    'tamil': 'ta'
  }
  
  export const getLangCode = (lang) => {
    return languageCode[lang];
  }
